import _classCallCheck from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { EventBus } from '@vtblife/event-bus';
export var EventsManager = /*#__PURE__*/function () {
  function EventsManager() {
    _classCallCheck(this, EventsManager);
    this.eventBus_ = new EventBus();
    this.subscriptions_ = [];
  }
  _createClass(EventsManager, [{
    key: "dispose",
    value: function dispose() {
      this.subscriptions_.forEach(function (sub) {
        return sub.unsubscribe();
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(eventType, handler) {
      var subscription = this.eventBus_.subscribe(eventType, handler, {
        eventCategory: 'behavior'
      });
      this.subscriptions_.push(subscription);
      return subscription;
    }
  }, {
    key: "publish",
    value: function publish(eventType, data) {
      var event = {
        type: eventType,
        category: 'behavior',
        data: data
      };
      this.eventBus_.publish(event);
    }
  }]);
  return EventsManager;
}();